import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const CorpulDeInspectie: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Corpul de Inspecție și Control
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Dorien Chiochiu
          </Typography>
          <Typography variant="body1">
            Corpul de Inspecție și Control se ocupă de monitorizarea și 
            controlul activităților din cadrul eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CorpulDeInspectie;
